import React from "react"
import { Text } from "~/ui/primitives"
import { observer } from "mobx-react-lite"
import styled from '~/ui/styled'
import Icon from "~widgets/icon"
import { Message } from "../../models"
import { formatBytes } from "../../utils"
import Progress from "./progress"
import { MessageStatus } from "~proto"
import { hapticTrigger } from "../../utils/haptic"
import { useTheme } from '~/ui/styled'
import useFileSystem from "~hooks/useFileSystem"
import MessageSent from "./message-sent"
import MessageReceived from "./message-received"
import { MessageProps } from "./message.props"

const Container = styled.View`
  width: ${({ theme }) => `${theme.window.width * 0.75}px`};
`

const FileMessageTouchableWrap = styled.Pressable`
  width: 100%;
  flex-direction: row;
  align-items: stretch;
`

const IconSquare = styled.Pressable`
  margin-right: 10px;
  width: 50px;
  height: 50px;
  background-color: ${({ theme }) => theme.colors.blockBackground};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 25px;
  border: 2px solid ${({ theme }) => theme.colors.border};
`

const RightContentArea = styled.View`
  justify-content: space-around;
`

interface FileMessageProps {
  message: Message
  setPopupOptionListModal?: ({ visible, message }: { visible: boolean; message: Message }) => void
}

// 优化使用纯组件
export const FileMessage: React.FC<FileMessageProps> = observer(
  ({ message, setPopupOptionListModal }) => {
    const theme = useTheme()
    const { isDownloading, downloadFile } = useFileSystem()
    // 选中图片进行预览
    const onClick = () => {
      if (
        isDownloading &&
        ![MessageStatus.SENT, MessageStatus.DELIVERED, MessageStatus.READ].includes(message.status)
      ) {
        return
      }
      const url = message.attachURL
      const mimeType = message.attach.type
      downloadFile(url, mimeType)
    }

    const handleOnLongPress = () => {
      if (setPopupOptionListModal) {
        hapticTrigger()
        setPopupOptionListModal({ visible: true, message })
      }
    }

    return (
      <FileMessageTouchableWrap onLongPress={handleOnLongPress}>
        <IconSquare onClick={onClick}>
          <Icon name="file" color={theme.colors.primary} size={30} />
        </IconSquare>
        <RightContentArea>
          <Text numberOfLines={1} ellipsizeMode="middle">
            {message.attach.filename}
          </Text>
          {message.attach.size && <Text>{formatBytes(message.attach.size)}</Text>}
        </RightContentArea>
        <Progress
          progress={message.progress}
          inProgress={message.status === MessageStatus.UPLOADING}
          size={50}
        />
      </FileMessageTouchableWrap>
    )
  },
)
export const FileMessageWithContainer: React.FC<MessageProps & FileMessageProps> = (props) => {
  return (
    <Container>
      <FileMessage {...props} />
    </Container>
  )
}
export const WrappedFileMessage: React.FC<MessageProps & FileMessageProps> = (props) => {
  return props.message.byMe ? (
    <MessageSent {...props} Component={FileMessageWithContainer} />
  ) : (
    <MessageReceived {...props} Component={FileMessageWithContainer} />
  )
}
export default WrappedFileMessage
